/**
 * 观看主播的记录
 * @author  fulh
 * @update 2013年8月13日 10:42:55
 *
 * {
 *     room_id:1,
 *     nick_name:'xxxx',
 *     user_pic:'xxxxx',
 *     pic_url:'',
 *     bean_count_total:0
 *  }
 */
$.module('MM.util.record', {
  _store_tag: 'MEME_VIEWRECORD',
  MAX_LENGTH: 12, //最大保存数量
  store: function (anchorInfo) {
    var list = this.getList();
    for (var i = 0, length = list.length; i < length; i++) {
      var item = list[i];
      if (item.room_id == anchorInfo.room_id) {
        list.splice(i, 1);
        break;
      }
    }

    list.splice(0, 0, anchorInfo); //unshift

    if (list.length > this.MAX_LENGTH) {
      list.splice(this.MAX_LENGTH);
    }
    // MM.core.debug("viewRecord-store", list);
    $.store.set(this._store_tag, list);
  },
  getList: function () {
    return $.store.get(this._store_tag) || [];
  },
});
